import { render, staticRenderFns } from "./mediaPhoto.vue?vue&type=template&id=43332b2f&scoped=true&"
import script from "./mediaPhoto.vue?vue&type=script&lang=js&"
export * from "./mediaPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43332b2f",
  null
  
)

export default component.exports